import { Api } from "@/core/api.js";
const api = new Api();
import i18n from "@/i18n";

// initial state
const state = {
  list: [],
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {},
  rooming: [],
  category_selected: false,
  rel_volunteer_list: []
};

// getters
const getters = {
  getRelVolunteerList: (state, getters, rootState) => () => {
    return state.rel_volunteer_list;
  },

  getList: (state, getters, rootState) => (type) => {
    var aTeams = [];
    for (var i in state.list) {
      if (state.list[i].list_visible) aTeams.push(state.list[i]);
    }
    return aTeams;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getListKeyId: (state, getters, rootState) => (id) => {
    return id ? state.list[id] : state.list;
  },

  getStatusDocuments: (state, getters, rootState) => () => {
    return [
      { id: "1", name: i18n.t("documents.status_1") },
      { id: "2", name: i18n.t("documents.status_2") },
    ];
  },

  getListWithCategory: (state, getters, rootState) => (type) => {
    var aTeams = [];
    for (var i in state.list) {
      var team = { ...state.list[i] };
      team.name = team.name + " - " + team.category.name;

      if (state.list[i].list_visible) aTeams.push(team);
    }
    return aTeams;
  },

  getListNoFiltered: (state, getters, rootState) => (type) => {
    var aTeams = [];
    for (var i in state.list) {
      aTeams.push(state.list[i]);
    }
    return aTeams;
  },

  get_by_id: (state, getters, rootState) => (id) => {
    if (typeof state.list[id] !== "undefined") {
      var team = { ...state.list[id] };
      for (var k in team) {
        if (team[k] == "true") team[k] = true;
        else if (team[k] == "false") team[k] = false;
        else if (parseInt(team[k]) == team[k]) team[k] = parseInt(team[k]);
      }

      team.status = team.status + "";

      return team;
    }
    return false;
  },

  getCategorySelected: (state, getter, rootState) => {
    return state.category_selected;
  },

  getInsuredOptions: (state, getter, rootState) => () => {
    return {
      0: { id: 0, name: "nsnc" },
      1: { id: 1, name: "si" },
      2: { id: 2, name: "no" },
    };
  },

  getListByCategory: (state, getters, rootState) => (category_id) => {
    var aTeams = [];
    for (var i in state.list) {
      if (state.list[i].category.id == category_id) aTeams.push(state.list[i]);
    }
    return aTeams;
  },

  getRooming: (state, getters, rootState) => {
    return JSON.parse(JSON.stringify({ ...state.rooming }));
  },
};

// actions
const actions = {
  loadList({ commit, state }, params) {
    var path =
      "team" +
      (typeof params !== "undefined" && typeof params.event !== "undefined"
        ? "/event/" + params.event
        : "");
    var page_options =
      params && params.page_options ? params.page_options : state.pagination;
    var filters =
      params && params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);
    return api.post(path, oParams).then(function (response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].list_visible = true;
        }

        commit("setList", { data: data, total: response.data.total });
        return commit("setPagination", page_options);
      }
    });
  },

  load_by_id({ commit }, params) {
    var path = "team/" + params.id;
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.list_visible = true;

        data.n_housed = Object.values(data.acompanyants).length;

        for (var i in data.players) {
          if (data.players[i].modality == "1") {
            data.n_housed++;
          }
        }

        for (var i in data.staff) {
          if (data.staff[i].modality == "1") {
            data.n_housed++;
          }
        }

        commit("addTeam", data);
        return data;
      }
    });
  },

  upload(context, data) {
    var team = { ...data.data };
    team.event = data.event;

    // team.insured = team.insured == 1 ? 1 : 2;

    if (typeof team.how_meet_id !== "undefined")
      team.how_meet = team.how_meet_id;

    var params = data.params;
    var path =
      typeof team.id !== "undefined"
        ? "team/" + team.id + "/update"
        : "team/add";
    return api.post(path, team).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.list_visible = true;

        context.commit("addTeam", data);
        return data.id;
      }
    });
  },

  remove(context, id) {
    return api.post("team/" + id + "/remove", {}).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.list_visible = true;

        context.commit("removeTeam", id);
      }
    });
  },

  changeStatus(context, params) {
    return api
      .post("team/" + params.id + "/update/status", { status: params.status })
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.list_visible = true;

          context.commit("addTeam", data);
        }
      });
  },

  createUserZE(context, params) {
    return api
      .post("team/" + params.team_id + "/addGestor", {
        username: params.username,
        name: params.name,
        password: params.password,
        language: params.language,
        email: params.email,
      })
      .then(function (response) {
        if (response.status) {
          return true;
        } else {
          throw response.error.message;
        }
      });
  },

  loadCredential: ({ commit }, params) => {
    return api
      .get("team/" + params.team_id + "/credentials")
      .then(function (response) {
        return response;
      });
  },

  loadCredentialsInfo: ({ commit }, params) => {
    return api
      .get("team/" + params.event_id + "/credentials/info")
      .then(function (response) {
        return response.data;
      });
  },

  fetchRelVolunteerList({ commit }, params) {
    var path = "team/" + params.id + "/event/" + params.event + "/entity-events";
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data;
        commit("setRelVolunteerList", { data });
        return data;
      }
    });
  },

  updateTransferVisible: ({ commit }, params) => {
    return api
      .post("team/" + params.team_id + "/update/transfervisible", {
        visible: params.visible,
      })
      .then(function (response) {
        return response.data;
      });
  },

  updateDeadlines: ({ commit }, params) => {
    return api
      .postJSON("team/" + params.team_id + "/update/deadlines", {
        steps: params.steps,
      })
      .then(function (response) {
        return response.data;
      });
  },

  updatePersonValidation: ({ commit }, params) => {
    return api
      .get("team/" + params.team_id + "/validate/" + params.id + "/" + params.type)
      .then(function (response) {
        return response.data;
      });
  },

  updatePersonData: ({ commit }, params) => {
    const data = { errors: JSON.stringify(params.errors) };
    return api
      .post("team/" + params.team_id + "/update-data/" + params.id + "/" + params.type, data)
      .then(function (response) {
        return response.data;
      });
  },

  updateArribadaVisible: ({ commit }, params) => {
    return api
      .post("team/" + params.team_id + "/update/arribadavisible", {
        visible: params.visible,
      })
      .then(function (response) {
        return response.data;
      });
  },

  updateSortidaVisible: ({ commit }, params) => {
    return api
      .post("team/" + params.team_id + "/update/sortidavisible", {
        visible: params.visible,
      })
      .then(function (response) {
        return response.data;
      });
  },

  updateHotelsVisible: ({ commit }, params) => {
    return api
      .post("team/" + params.team_id + "/update/hotelsvisible", {
        visible: params.visible,
      })
      .then(function (response) {
        return response.data;
      });
  },

  // ROOMING
  loadRooming({ commit }, params) {
    return api
      .get("team/" + params.team_id + "/event/" + params.event_id + "/rooming")
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          for (var i in data) {
            data[i].alergy = data[i].alergy == "1";
            data[i].rooms = parseInt(
              parseInt(data[i].num_rooms_1pax) +
                parseInt(data[i].num_rooms_2pax) +
                parseInt(data[i].num_rooms_3pax) +
                parseInt(data[i].num_rooms_4pax) +
                parseInt(data[i].num_rooms_5pax)
            );
            data[i].pax =
              parseInt(data[i].num_rooms_1pax) * 1 +
              parseInt(data[i].num_rooms_2pax) * 2 +
              parseInt(data[i].num_rooms_3pax) * 3 +
              parseInt(data[i].num_rooms_4pax) * 4 +
              parseInt(data[i].num_rooms_5pax) * 5;

            data[i].selected = false;
          }

          return commit("setRooming", data);
        }
      });
  },

  loadCategoryRooming({ commit }, params) {
    return api
      .get(
        "team/category/" +
          params.category_id +
          "/event/" +
          params.event_id +
          "/rooming"
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          for (var i in data) {
            data[i].alergy = data[i].alergy == "1";
            data[i].rooms = parseInt(
              parseInt(data[i].num_rooms_1pax) +
                parseInt(data[i].num_rooms_2pax) +
                parseInt(data[i].num_rooms_3pax) +
                parseInt(data[i].num_rooms_4pax) +
                parseInt(data[i].num_rooms_5pax)
            );
            data[i].pax =
              parseInt(data[i].num_rooms_1pax) * 1 +
              parseInt(data[i].num_rooms_2pax) * 2 +
              parseInt(data[i].num_rooms_3pax) * 3 +
              parseInt(data[i].num_rooms_4pax) * 4 +
              parseInt(data[i].num_rooms_5pax) * 5;

            data[i].selected = false;
          }

          return commit("setRooming", data);
        }
      });
  },

  loadMultipleCategoryRooming({ commit }, params) {
    return api
      .post("team/category/multiple/event/" + params.event_id + "/rooming", {
        category_id: params.category_id,
      })
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          for (var i in data) {
            data[i].alergy = data[i].alergy == "1";
            data[i].rooms = parseInt(
              parseInt(data[i].num_rooms_1pax) +
                parseInt(data[i].num_rooms_2pax) +
                parseInt(data[i].num_rooms_3pax) +
                parseInt(data[i].num_rooms_4pax) +
                parseInt(data[i].num_rooms_5pax)
            );
            data[i].pax =
              parseInt(data[i].num_rooms_1pax) * 1 +
              parseInt(data[i].num_rooms_2pax) * 2 +
              parseInt(data[i].num_rooms_3pax) * 3 +
              parseInt(data[i].num_rooms_4pax) * 4 +
              parseInt(data[i].num_rooms_5pax) * 5;

            data[i].selected = false;
          }

          return commit("setRooming", data);
        }
      });
  },

  saveRooming(context, data) {
    var newRooming = { ...data.data };

    newRooming.alergy = newRooming.alergy ? 1 : 0;
    var path = "team/" + data.team_id + "/event/" + data.event_id + "/rooming/";
    data.isEdit ? (path += newRooming.id + "/update") : (path += "add");

    return api.post(path, newRooming).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return true;
      } else return false;
    });
  },

  removeRooming(context, data) {
    var path =
      "team/" +
      data.team_id +
      "/event/" +
      data.event_id +
      "/rooming/" +
      data.rooming_id +
      "/remove";
    return api.post(path, {}).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return true;
      } else return false;
    });
  },

  sendImageRight(context, params) {
    var path = "team/";
    if (params.team_id) {
      path += params.team_id;
      path += "/event/" + params.event_id + "/send/image-right";
      return api.get(path).then(function (response) {
        if (response.status) {
          return true;
        } else return false;
      });
    } else {
      path += "event/" + params.event_id + "/send/image-right";
      return api.post(path, params.params).then(function (response) {
        if (response.status) {
          return true;
        } else return false;
      });
    }
  },
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  addTeam(state, team) {
    var list = { ...state.list };
    list[team.id] = team;

    state.list = list;
  },

  removeTeam(state, id) {
    var list = { ...state.list };
    delete list[id];

    state.list = list;
  },

  addNote(state, { id, note }) {
    var list = { ...state.list };
    list[id].notes[note.id] = note;

    state.list = list;
  },

  removeNote(state, { id, note }) {
    var list = { ...state.list };
    delete list[id].notes[note];

    state.list = list;
  },

  applyFilters(state, filters) {
    state.current_filters = filters;
    // var list = { ...state.list };
    // if (!filters) {
    //   state.category_selected = false;
    //   for (var i in list) {
    //     list[i].list_visible = true;
    //   }
    // } else {
    //   for (var i in list) {
    //     list[i].list_visible = false;
    //   }
    //   for (var i in list) {
    //     var item = list[i];
    //     // console.log( " ---- ITEM " + item.name + " --- " );
    //     var bFoundCategory = false;
    //     var bFound = true;
    //     for (var k in filters) {
    //       // console.log( "--- KEY: " + k + " ---" )
    //       // var item_value = ( item[k] != null && typeof item[k] == 'object' )? item[k].id : item[k];
    //       // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] );
    //       // var regexp = new RegExp( filters[k].trim(), "gi" );
    //       // if( item.hasOwnProperty( k ) && typeof item[k] == 'object' && filters[ k ] != item_value ) {
    //       //   bFound = false;
    //       // }
    //       // else if( item.hasOwnProperty( k ) && typeof item[k] !== 'object' && !item_value.match( regexp ) ){
    //       //     bFound = false;
    //       // }
    //       if (filters[k] != -1) {
    //         if (k == "category") {
    //           bFoundCategory = true;
    //           state.category_selected = filters[k];
    //         }
    //         if (k == "gestor_id") {
    //           if (item.club.gestor_id !== filters[k]) {
    //             bFound = false;
    //           }
    //         } else {
    //           var item_value =
    //             item[k] != null && typeof item[k] == "object"
    //               ? item[k].id
    //               : item[k];
    //           if (
    //             item.hasOwnProperty(k) &&
    //             filters[k] == null &&
    //             item_value == null
    //           ) {
    //           } else {
    //             console.log(
    //               "KEY SEARCH: " +
    //                 k +
    //                 " ITEM: " +
    //                 item_value +
    //                 " - FILTER: " +
    //                 filters[k] +
    //                 " " +
    //                 typeof filters[k]
    //             );
    //             // filters[k] = filters[k] == null ? null : ( typeof filters[k] !== 'string' ? ( typeof filters[k] !== 'boolean' ? ( filters[k] ? 1 : 0 ) : filters[k] ) : filters[k].trim() )

    //             if (filters[k] != null && typeof filters[k] === "boolean")
    //               filters[k] = filters[k] ? 1 : 0;
    //             else if (filters[k] != null && typeof filters[k] === "string")
    //               filters[k] = filters[k].trim();

    //             // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //             var regexp = new RegExp(filters[k], "gi");

    //             if (
    //               item.hasOwnProperty(k) &&
    //               typeof item[k] == "object" &&
    //               filters[k] != item_value
    //             ) {
    //               bFound = false;
    //             } else if (
    //               item.hasOwnProperty(k) &&
    //               typeof item[k] !== "object" &&
    //               !item_value.match(regexp)
    //             ) {
    //               bFound = false;
    //             }
    //           }
    //         }
    //       }
    //     }
    //     if (!bFoundCategory) {
    //       state.category_selected = false;
    //     }

    //     list[i].list_visible = bFound;
    //   }
    // }

    // state.list = list;
  },

  setCategorySelected(state, value) {
    state.category_selected = value;
  },

  setRooming(state, data) {
    state.rooming = data;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setRelVolunteerList(state, { data }) {
    state.rel_volunteer_list = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
